import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from '@wix/wix-i18n-config';
import App from './components/App';
import { BrowserRouter } from 'react-router-dom';
import { InitialStateProvider } from './contexts/InitialStateContext';
import { clientI18n } from './i18n/client-i18n';
import { BiLoggerProvider } from './contexts/BILoggerContext';
import { FedopsLoggerProvider } from './contexts/FedopsLoggerContext';
import { HelmetProvider } from 'react-helmet-async';
import { ExperimentsProvider } from './contexts/ExperimentsContext';
import { initCookieAndTagManagers } from './utils/initCookieAndTagManagers';
import { initWixRecorder } from './utils/initWixRecorder';

(() => {
  const initialState = window.__INITIAL_STATE__;
  const { appSpecs, baseUrl, locale: language, consentPolicy } = initialState;
  initWixRecorder(appSpecs);
  initCookieAndTagManagers({ baseUrl, language, consentPolicy });

  const initialI18n = window.__INITIAL_I18N__;
  const i18nInstance = clientI18n(initialI18n);

  // Move the following `appLoaded()` call to the point where your app has fully loaded.
  // See https://github.com/wix-private/fed-infra/blob/master/fedops/fedops-logger/README.md

  const root = createRoot(document.getElementById('root')!);

  const basename = window.__BASENAME__;

  root.render(
    <Suspense fallback="...loading">
      <HelmetProvider>
        <InitialStateProvider initialState={initialState}>
          <I18nextProvider i18n={i18nInstance}>
            <BrowserRouter basename={basename}>
              <BiLoggerProvider>
                <FedopsLoggerProvider>
                  <ExperimentsProvider>
                    <App />
                  </ExperimentsProvider>
                </FedopsLoggerProvider>
              </BiLoggerProvider>
            </BrowserRouter>
          </I18nextProvider>
        </InitialStateProvider>
      </HelmetProvider>
    </Suspense>,
  );
})();
